import type { FindFilterCountsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

// Faceted filter-option counts for the products toolbar. Each dimension
// (countries / catalogs / categories / valueTiers) excludes its own filter
// server-side, so the dropdowns stay dynamic — selecting a country narrows
// the category counts, etc. `keepPreviousData` keeps the prior options on
// screen while a new combination is fetched so the dropdowns don't blink.
export const useProductFilterCounts = (input: FindFilterCountsInput) =>
  trpc.products.filterCounts.useQuery(input, {
    placeholderData: keepPreviousData,
  });
